import { render, staticRenderFns } from "./UpIconSvg.vue?vue&type=template&id=6cd906b2&"
import script from "./UpIconSvg.vue?vue&type=script&lang=js&"
export * from "./UpIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports